import type { AuthUser } from "../lib/api";

/** Cuenta solo de árbitro (2026-10-16): sub-usuario del Equipo con perfil
 * «arbitro». Su casa es «Mis partidos» (/arbitro); el servidor le cierra el
 * panel del organizador. Módulo aparte para que las pruebas que simulan
 * AuthContext no tengan que conocerlo. */
export function isRefereeAccount(user: AuthUser | null | undefined): boolean {
  return !!user && !!user.managed_by_user_id && user.team_profile === "arbitro";
}
